module.exports = {
  title: 'React Native Animated Clip Box Animation 📦',
  author: 'Enzo Manuel Mangano',
  date: '2023-01-25',
  slug: 'animated-clip-box',
  tags: ['reanimated', 'skia'],
};
